
    import styled from 'styled-components';

    // ----------
    //  Elements
    // ----------

        export const H1Element = ({ className, text, ...props }) =>
            <h1 className={ className } dangerouslySetInnerHTML={{ __html : text }} {...props} />

        export const H2Element = ({ className, text, ...props }) =>
            <h2 className={ className } dangerouslySetInnerHTML={{ __html : text }} {...props} />

        export const H3Element = ({ className, text, ...props }) =>
            <h3 className={ className } dangerouslySetInnerHTML={{ __html : text }} {...props} />

        export const H4Element = ({ className, text, ...props }) =>
            <h4 className={ className } dangerouslySetInnerHTML={{ __html : text }} {...props} />

        export const H5Element = ({ className, text, ...props }) =>
            <h5 className={ className } dangerouslySetInnerHTML={{ __html : text }} {...props} />

        export const H6Element = ({ className, text, ...props }) =>
            <h6 className={ className } dangerouslySetInnerHTML={{ __html : text }} {...props} />

        export const ParagraphElement = ({ className, text, ...props }) =>
            <p className={ className } dangerouslySetInnerHTML={{ __html : text }} {...props} />

        export const SpanElement = ({ className, text, ...props }) =>
            <span className={ className } dangerouslySetInnerHTML={{ __html : text }} {...props} />

        export const Anchor = ({ className, text, ...props }) =>
            <a className={ className } dangerouslySetInnerHTML={{ __html : text }} {...props} />
        
        export const PreElement = ({ className, text, ...props }) =>
            <pre className={ className } dangerouslySetInnerHTML={{ __html : text }} {...props} />

        export const ULElement = ({ className, text, ...props }) =>
            <ul className={ className } dangerouslySetInnerHTML={{ __html : text }} {...props} />

        export const OLElement = ({ className, text, ...props }) =>
            <ol className={ className } dangerouslySetInnerHTML={{ __html : text }} {...props} />

        export const LIElement = ({ className, text, ...props }) =>
            <li className={ className } dangerouslySetInnerHTML={{ __html : text }} {...props} />

    // -------------------
    //  Styled Components
    // -------------------

        export const H1TitleComponent = styled(H1Element)`
            
        `;
